module.exports = __webpack_public_path__ + "img/home_bnaner2.c52e6f3b.jpg";